/**
 * **조사 붙이기** — 한국어 낱말 뒤의 조사는 앞 글자의 받침으로 고르고 붙여 쓴다(«카드는»·«카드가»·«에디트를»). 앞 글자가 한글이 아니면
 * (카드 번호 «450» 같은 숫자·로마자) 받침을 글자로 정할 수 없어 문구가 적은 꼴을 그대로 띄어 쓴다(«450 는»·«450 이(가)» — 사건 문구의
 * 오랜 꼴). 문구는 조사를 짝의 어느 꼴(«는»·«은(는)»)로 적어도 된다 — 짝이면 받침이 고르고, 짝이 없는 조사(«의»)는 그대로 붙는다.
 */
const PAIRS: readonly (readonly [afterFinal: string, afterVowel: string])[] = [['은', '는'], ['이', '가'], ['을', '를'], ['과', '와']];

const pairOf = (particle: string) => PAIRS.find(([a, b]) => particle === a || particle === b || particle === `${a}(${b})`);

/** 한글 음절의 받침 유무 — 한글 음절이 아니면 undefined */
const hasFinal = (ch: string): boolean | undefined => {
  const at = ch.charCodeAt(0) - 0xac00;
  return at >= 0 && at < 11172 ? at % 28 !== 0 : undefined;
};

export function withParticle(text: string, particle: string): string {
  const final = text ? hasFinal(text[text.length - 1]) : undefined;
  if (final === undefined) return `${text} ${particle}`;
  const pair = pairOf(particle);
  return text + (pair ? pair[final ? 0 : 1] : particle);
}
